module.exports = __webpack_public_path__ + "static/media/AdUnitStep2.ab0df0a4.svg";